import { ISiteSetting, ITeam } from "../../../../../types/api";

const getTeamAgeLevel = (
    team: ITeam | undefined,
    currentYear: ISiteSetting | undefined,
) => {
    let ageLevel: ITeam["ageLevels"][number]["ageLevel"] | undefined;

    if (currentYear) {
        // attempt get current year's age level
        ageLevel = team?.ageLevels.find(
            ta => ta.year === parseInt(currentYear.setting),
        )?.ageLevel;
    }

    if (!currentYear || !ageLevel) {
        // get team's most recent age level
        ageLevel = team?.ageLevels.reduce((prev, current) => {
            return new Date(current.year, current.season.id) >
                new Date(prev.year, prev.season.id)
                ? current
                : prev;
        }, team.ageLevels[0])?.ageLevel;
    }

    return ageLevel;
};

export default getTeamAgeLevel;
